import { Component, Input } from '@angular/core';
import { ActionItem, AppClientConfigurationService, AppServerAPI, DateUtilsService, DialogService } from '@sdbn/common';
import { TransportDetailLayout, TransportDetailMode } from '../../../common/configuration/transport.configuration';
import { Transport } from '../../../common/model/transport.model';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { AsyncSubject, interval, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { VisitService } from '../../visit-overview/service/visit.service';
import { TransportDetailsLayoutConverter } from '../../../common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailsLayoutService } from '../../transport-details/transport-details-layout.service';
import { RegisterLeaveCombinedComponent, RegisterLeaveCombinedDialogData } from '../../visit-overview/component/register-leave-combined/register-leave-combined.component';
import { RegisterLeaveComponent, RegisterLeaveDialogData } from '../../visit-overview/dialog/register-leave/component/register-leave.component';
import { TransportAssignmentSelection, TransportAssignmentSight } from './action-tablet-planned-assignments.model';
import { TmcContextService } from '../../../common/tmc-context.service';
import { ActionTabletPlannedAssignmentsActionDialogComponent } from './action-tablet-planned-assignments-action-dialog/action-tablet-planned-assignments-action-dialog.component';

@Component({
    selector: 'yard-action-tablet-planned-assignments',
    templateUrl: './action-tablet-planned-assignments.component.html',
    styleUrls: ['./action-tablet-planned-assignments.component.scss'],
    standalone: false
})
export class ActionTabletPlannedAssignmentsComponent {

  @Input() actionItem: ActionItem;

  transportAssignments = new Array<TransportAssignmentSight>();

  clientParameters = TMCClientParameters;



  timerSubscription: Subscription;

  constructor(
    public cps: AppClientConfigurationService,
    private appServerApi: AppServerAPI,
    private dialog: MatDialog,
    private visitService: VisitService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter,
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    public dateUtilsService: DateUtilsService,
    private tmcContextService: TmcContextService,
    private dialogService: DialogService
  ) {


  }

  ngOnInit(): void {

    this.loadAssignments();

    if (this.actionItem.refreshTimer > 0) {

      this.timerSubscription = interval(this.actionItem.refreshTimer * 1000).subscribe(n => {
        this.loadAssignments();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }

  handleClick(transportAssignmentSight: TransportAssignmentSight) {

    this.dialogService.openDefault(ActionTabletPlannedAssignmentsActionDialogComponent, transportAssignmentSight).afterClosed().subscribe(result => {


    });


    // var data = JSON.parse(this.actionItem.data);

    /* entrance action */
    // if (data.action === 'entrance') {
    //   this.visitService.openRegisterEntranceDialog(transport.id, () => { });
    // }

    /* leave action */
    // if (data.action === 'leave') {
      // if (this.cps.isPropertyTrue(this.clientParameters.FEATURES_COMBINED_LEAVE, false)) {
      //   const dialogData: RegisterLeaveCombinedDialogData = {
      //     transportId: transport.id,
      //     callback: () => {
      //       this.loadAssignments();
      //     }
      //   };

      //   this.dialog.open(RegisterLeaveCombinedComponent, {
      //     maxHeight: '95vh',
      //     data: dialogData
      //   });
      // } else {
      //   const dialogData: RegisterLeaveDialogData = {
      //     transportId: transport.id,
      //     callback: () => {
      //       this.loadAssignments();
      //     }
      //   };

      //   this.dialog.open(RegisterLeaveComponent, {
      //     maxHeight: '95vh',
      //     data: dialogData
      //   });
      // }
    // }
  }

  private loadAssignments(): AsyncSubject<void> {

    var data = JSON.parse(this.actionItem.data);

    const selection = new TransportAssignmentSelection({
      transportOptions: data.transportOptions != null ? data.transportOptions : [],
      stationSetIds: data.stationSetIds != null ? data.stationSetIds : []
    });
    
    const subject = new AsyncSubject<void>();
    this.appServerApi.execute<Array<TransportAssignmentSight>>('/tmc-yard/control/transport-assignment-action-tablet/findAll', selection).subscribe(response => {
      let transportAssignments = new Array<TransportAssignmentSight>();
      for (const transport of response) {
        transportAssignments.push(new TransportAssignmentSight(transport));
      }
      this.transportAssignments = transportAssignments;
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

}
